var path = '/templates/zenclerk_s/common/product_changes/product_changes.html';
var html = "<div class=product-changes><div class=product-changes__body><div class=\"product-changes__entry product-changes__empty\">{{ 'common.productChanges.noUpdate' | translate }}</div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/common/product_changes/product_changes.html
// module id = 1314
// module chunks = 0